import * as Yup from 'yup';

const createCustomApplicationFormSchema = ({
  sectionFields
}: {
  sectionFields: Record<string, string>;
}) => {
  const shape: { [key: string]: any } = {};

  try {
    const fields: string[] = Object.keys(sectionFields);

    fields.forEach((field) => {
      if (field.includes('sectionRole')) {
        // Validate that sectionRole is a stringified array with at least one element
        shape[field] = Yup.string()
          .test(
            'is-valid-array',
            'Please add at least one role in this field',
            (value) => {
              if (!value) return false; // Ensure value exists
              try {
                const parsed = JSON.parse(value); // Parse the stringified array
                return Array.isArray(parsed) && parsed.length > 0; // Validate it's a non-empty array
              } catch (e) {
                return false; // Return false if parsing fails
              }
            }
          )
          .required('Please enter roles in this field');
      } else {
        // Make other fields required
        shape[field] = Yup.string().required('Please enter details in this field');
      }
    });

    return Yup.object().shape(shape);
  } catch {
    return Yup.object().shape(shape);
  }
};

export default createCustomApplicationFormSchema;
